export { default } from '@/components/pages/MyInvestments/MyInvestments'

export async function getServerSideProps() {
  return {
    props: {
      seo: {
        title: 'Your Investments',
      },
    },
  }
}
